export const ROLE_ADA = "ROLE_ADA";
export const ROLE_ADV = "ROLE_ADV";
export const ROLE_ASSOC = "ROLE_ASSOC";
export const ROLE_CDG = "ROLE_CDG";
export const ROLE_CEO = "ROLE_CEO";
export const ROLE_COMPTA = "ROLE_COMPTA";
export const ROLE_CSE = "ROLE_CSE";
export const ROLE_CSLT = "ROLE_CSLT";
export const ROLE_EVT_CE_CR = "ROLE_EVT_CE_CR";
export const ROLE_EVT_CE_VW = "ROLE_EVT_CE_VW";
export const ROLE_EVT_EV_VAL = "ROLE_EVT_EV_VAL";
export const ROLE_EVT_SF_CR = "ROLE_EVT_SF_CR";
export const ROLE_EVT_SF_VW = "ROLE_EVT_SF_VW";
export const ROLE_EVT_TR_CR = "ROLE_EVT_TR_CR";
export const ROLE_EVT_TR_VAL = "ROLE_EVT_TR_VAL";
export const ROLE_GP = "ROLE_GP";
export const ROLE_LCS = "ROLE_LCS";
export const ROLE_LCSC = "ROLE_LCSC";
export const ROLE_LEG = "ROLE_LEG";
export const ROLE_LT = "ROLE_LT";
export const ROLE_MGR = "ROLE_MGR";
export const ROLE_FORMATION = "ROLE_FORMATION";
export const ROLE_IA = "ROLE_IA";
export const ROLE_MGR_CLIENT = "ROLE_MGR_CLIENT";
export const ROLE_NDF_ADV = "ROLE_NDF_ADV";
export const ROLE_NDF_COMPTA = "ROLE_NDF_COMPTA";
export const ROLE_NDF_GP = "ROLE_NDF_GP";
export const ROLE_NDF_MANAGER = "ROLE_NDF_MANAGER";
export const ROLE_NDF_SEC = "ROLE_NDF_SEC";
export const ROLE_PLPM = "ROLE_PLPM";
export const ROLE_RADV = "ROLE_RADV";
export const ROLE_RGN_ASSIST = "ROLE_RGN_ASSIST";
export const ROLE_RGP = "ROLE_RGP";
export const ROLE_SUPPORT = "ROLE_SUPPORT";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_MASCARADE = "ROLE_MASCARADE";
export const ROLE_TWISTER = "ROLE_TWISTER";
export const STAFF_ROLES = {
  ROLE_GET_STAFF: "ROLE_GET_STAFF",
  ROLE_READ_STAFF: "ROLE_READ_STAFF",
  ROLE_MACRO_AS_READ_STAFF: "ROLE_MACRO_AS_READ_STAFF",
  ROLE_CREATE_STAFF: "ROLE_CREATE_STAFF",
};
export const CONSULTANT_ROLES = {
  ROLE_GET_CONSULTANT: "ROLE_GET_CONSULTANT",
  ROLE_CREATE_CONSULTANT: "ROLE_CREATE_CONSULTANT",
};
export const SUBCONTRACTOR_ROLES = {
  ROLE_GET_SUBCONTRACTOR: "ROLE_GET_SUBCONTRACTOR",
  ROLE_CREATE_SUBCONTRACTOR: "ROLE_CREATE_SUBCONTRACTOR",
};
export const CLIENT_ROLES = {
  ROLE_GET_CLIENT: "ROLE_GET_CLIENT",
  ROLE_CREATE_CLIENT: "ROLE_CREATE_CLIENT",
  ROLE_READ_CLIENT: "ROLE_READ_CLIENT",
};
export const SUBCONTRACTOR_COMPANY_ROLES = {
  ROLE_GET_SUBCONTRACTOR_COMPANY: "ROLE_GET_SUBCONTRACTOR_COMPANY",
  ROLE_CREATE_SUBCONTRACTOR_COMPANY: "ROLE_CREATE_SUBCONTRACTOR_COMPANY",
  ROLE_READ_SUBCONTRACTOR_COMPANY: "ROLE_READ_SUBCONTRACTOR_COMPANY",
  ROLE_UPDATE_SUBCONTRACTOR_COMPANY: "ROLE_UPDATE_SUBCONTRACTOR_COMPANY",
  ROLE_ADMIN_SUBCONTRACTOR_COMPANY: "ROLE_ADMIN_SUBCONTRACTOR_COMPANY",
};
export const BILLING_CLIENT_ROLES = {
  ROLE_GET_BILLING_CLIENT: "ROLE_GET_BILLING_CLIENT",
  ROLE_CREATE_BILLING_CLIENT: "ROLE_CREATE_BILLING_CLIENT",
  ROLE_CREATE_BILLING_CLIENT_HISTORY: "ROLE_CREATE_BILLING_CLIENT_HISTORY",
};
export const MISSION_MANAGER_ROLES = [ROLE_MGR, ROLE_IA];
export const MISSION_ROLES = {
  ROLE_READ_MISSION: "ROLE_READ_MISSION",
  ROLE_GET_MISSION: "ROLE_GET_MISSION",
  ROLE_CREATE_MISSION: "ROLE_CREATE_MISSION",
  ROLE_CREATE_MISSION_BILL: "ROLE_CREATE_MISSION_BILL",
  ROLE_READ_MISSION_LIST: "ROLE_READ_MISSION_LIST",
  ROLE_UPDATE_MISSION: "ROLE_UPDATE_MISSION",
  ROLE_ADMIN_MISSION: "ROLE_ADMIN_MISSION",
  ROLE_MACRO_AS_ADMIN_MISSION: "ROLE_MACRO_AS_ADMIN_MISSION",
  ROLE_GET_MISSION_LIST: "ROLE_GET_MISSION_LIST",
  ROLE_READ_MISSION_BILL: "ROLE_READ_MISSION_BILL",
  ROLE_ADMIN_MISSION_BILL: "ROLE_ADMIN_MISSION_BILL",
  ROLE_UPDATE_MISSION_BILL: "ROLE_UPDATE_MISSION_BILL",
};
export const DASHBOARD_ROLES = {
  ROLE_GET_DASHBOARD: "ROLE_GET_DASHBOARD",
  ROLE_GET_DASHBOARD_IC: "ROLE_GET_DASHBOARD_IC",
  ROLE_GET_DASHBOARD_ED: "ROLE_GET_DASHBOARD_ED",
  ROLE_GET_DASHBOARD_CL: "ROLE_GET_DASHBOARD_CL",
  ROLE_GET_DASHBOARD_MISSIONS: "ROLE_GET_DASHBOARD_MISSIONS",
  ROLE_GET_DASHBOARD_BILLING_STATS: "ROLE_GET_DASHBOARD_BILLING_STATS",
  ROLE_GET_DASHBOARD_FAE: "ROLE_GET_DASHBOARD_FAE",
  ROLE_GET_DASHBOARD_RATIO: "ROLE_GET_DASHBOARD_RATIO",
};
export const ROLE_TOOL_MANAGER_CLIENT = "ROLE_TOOL_MANAGER_CLIENT";
export const ROLE_TOOL_MANAGER_WORKER = "ROLE_TOOL_MANAGER_WORKER";
export const ROLE_TOOL_MANAGER_PROSPECTION = "ROLE_TOOL_MANAGER_PROSPECTION";
export const ROLE_TOOL_MANAGER_SALARY = "ROLE_TOOL_MANAGER_SALARY";
export const ROLE_TOOL_MANAGER_MISSION = "ROLE_TOOL_MANAGER_MISSION";
export const ROLE_TOOL_MANAGER_FAF = "ROLE_TOOL_MANAGER_FAF";
// F&F declarants are IA or managers; associates (DSOC), the CEO and Twister
// staff never declare, whatever their other roles.
export const FAF_TOOL_ACCESS = {
  requiredRoles: [ROLE_TOOL_MANAGER_FAF],
  anyOfRoles: [ROLE_IA, ROLE_MGR],
  excludedRoles: [ROLE_ASSOC, ROLE_CEO, ROLE_TWISTER],
};
export const ROLE_GET_OBJECTIVE = "ROLE_GET_OBJECTIVE";
export const ROLE_READ_OBJECTIVE = "ROLE_READ_OBJECTIVE";
export const ROLE_GET_DASHBOARD_DIAGRAM_BAR = "ROLE_GET_DASHBOARD_DIAGRAM_BAR";
export const ROLE_IMPORT_MISSION_BILL = "ROLE_IMPORT_MISSION_BILL";
export const ROLE_GET_MISSION_BILL_TABLE = "ROLE_GET_MISSION_BILL_TABLE";
export const ROLE_GET_MISSION_BILL = "ROLE_GET_MISSION_BILL";
export const ROLE_GET_CORRESPONDANCE = "ROLE_GET_CORRESPONDANCE";
export const ROLE_TOOL_MANAGER = "ROLE_TOOL_MANAGER";
export const ROLE_GET_TIMELINE = "ROLE_GET_TIMELINE";

// Fast & Furious (faf) — weekly sourcing/recruitment declaration (Manager Tools).
// Granular per-entity roles, exposed by the datatrack back (cf. MR back !1008).
export const FAF_DECLARATION_ROLES = {
  ROLE_GET_DECLARATION: "ROLE_GET_DECLARATION",
  ROLE_CREATE_DECLARATION: "ROLE_CREATE_DECLARATION",
  ROLE_UPDATE_DECLARATION: "ROLE_UPDATE_DECLARATION",
};
export const FAF_PROSPECT_ROLES = {
  ROLE_GET_PROSPECT: "ROLE_GET_PROSPECT",
  ROLE_CREATE_PROSPECT: "ROLE_CREATE_PROSPECT",
  ROLE_UPDATE_PROSPECT: "ROLE_UPDATE_PROSPECT",
  ROLE_DELETE_PROSPECT: "ROLE_DELETE_PROSPECT",
};
export const FAF_NEED_ROLES = {
  ROLE_GET_NEED: "ROLE_GET_NEED",
  ROLE_CREATE_NEED: "ROLE_CREATE_NEED",
  ROLE_UPDATE_NEED: "ROLE_UPDATE_NEED",
};
export const FAF_QUALIF_ROLES = {
  ROLE_GET_QUALIF: "ROLE_GET_QUALIF",
  ROLE_CREATE_QUALIF: "ROLE_CREATE_QUALIF",
  ROLE_UPDATE_QUALIF: "ROLE_UPDATE_QUALIF",
};
export const MONTHLY_PAY_ROLES = {
  ROLE_GET_MONTHLY_PAY: "ROLE_GET_MONTHLY_PAY",
  ROLE_UPDATE_MONTHLY_PAY: "ROLE_UPDATE_MONTHLY_PAY",
  ROLE_DELETE_MONTHLY_PAY: "ROLE_DELETE_MONTHLY_PAY",
  ROLE_CRUD_MONTHLY_PAY: "ROLE_CRUD_MONTHLY_PAY",
};
export const ENTITY_CREATION_ROLES = {
  ROLE_CREATE_PERSON: "ROLE_CREATE_PERSON",
  ROLE_CREATE_PROSPECTION: "ROLE_CREATE_PROSPECTION",
  ROLE_CREATE_CONTRACT: "ROLE_CREATE_CONTRACT",
  ROLE_CREATE_COEF_SYNTEC: "ROLE_CREATE_COEF_SYNTEC",
  ROLE_CREATE_DOMAIN: "ROLE_CREATE_DOMAIN",
};
export const MISSION_BACKUP = {
  ROLE_CREATE_MISSION_BACKUP: "ROLE_CREATE_MISSION_BACKUP",
  ROLE_ADMIN_MISSION_BACKUP: "ROLE_ADMIN_MISSION_BACKUP",
  ROLE_UPDATE_TWISTER_BACKUP: "ROLE_UPDATE_TWISTER_BACKUP",
};
export const ROLE_DELETE_MISSION = "ROLE_DELETE_MISSION";

export const MISSION_FEE = {
  ROLE_GET_MISSION_FEE: "ROLE_GET_MISSION_FEE",
  ROLE_CREATE_MISSION_FEE: "ROLE_CREATE_MISSION_FEE",
  ROLE_UPDATE_MISSION_FEE: "ROLE_UPDATE_MISSION_FEE",
  ROLE_DELETE_MISSION_FEE: "ROLE_DELETE_MISSION_FEE",
  ROLE_CRUD_MISSION_FEE: "ROLE_CRUD_MISSION_FEE",
};
export const ROLE_SUBCONTRACTOR_LIST_EXPORT = "ROLE_SUBCONTRACTOR_LIST_EXPORT";

export const ROLE_MISSION_ORDER = "ROLE_MISSION_ORDER";

export const ROLE_SERVICE_CONTRACT = "ROLE_SERVICE_CONTRACT";

export const PROSPECTION = {
  ROLE_GET_PROSPECTION: "ROLE_GET_PROSPECTION",
  ROLE_CREATE_PROSPECTION: "ROLE_CREATE_PROSPECTION",
  ROLE_UPDATE_PROSPECTION: "ROLE_UPDATE_PROSPECTION",
  ROLE_READ_PROSPECTION: "ROLE_READ_PROSPECTION",
  ROLE_ADMIN_PROSPECTION: "ROLE_ADMIN_PROSPECTION",
};

export const ROLE_IMPORT_EXTERNAL_TRAINING = "ROLE_IMPORT_EXTERNAL_TRAINING";

export const MUTUAL_DASHBOARD_ROLES = {
  ROLE_GET_MUTUAL: "ROLE_GET_MUTUAL",
  ROLE_READ_MUTUAL: "ROLE_READ_MUTUAL",
  ROLE_GET_MUTUAL_IC: "ROLE_GET_MUTUAL_IC",
  ROLE_READ_MUTUAL_IC: "ROLE_READ_MUTUAL_IC",
  ROLE_GET_MUTUAL_FDM: "ROLE_GET_MUTUAL_FDM",
  ROLE_READ_MUTUAL_FDM: "ROLE_READ_MUTUAL_FDM",
  ROLE_GET_MUTUAL_ED: "ROLE_GET_MUTUAL_ED",
  ROLE_READ_MUTUAL_ED: "ROLE_READ_MUTUAL_ED",
  ROLE_READ_MUTUAL_KO: "ROLE_READ_MUTUAL_KO",
  ROLE_GET_MUTUAL_KO: "ROLE_GET_MUTUAL_KO",
  ROLE_GET_MUTUAL_CL: "ROLE_GET_MUTUAL_CL",
  ROLE_READ_MUTUAL_CL: "ROLE_READ_MUTUAL_CL",
  ROLE_GET_MUTUAL_OK: "ROLE_GET_MUTUAL_OK",
  ROLE_READ_MUTUAL_OK: "ROLE_READ_MUTUAL_OK",
};

export const ROLE_DUTLER = "dutler";
export const ROLE_NDF = "ndf";
export const ROLE_FMD = "fmd";
export const ROLE_JOB = "job";

export const ROLE_GROUPED_MAIL = "ROLE_GROUPED_MAIL";
export const ROLE_GET_DOMAIN = "ROLE_GET_DOMAIN";

export const ROLE_GET_BY_MODEL = {
  longleave: "ROLE_GET_LONGLEAVE",
  coef: "ROLE_GET_COEF_SYNTEC",
  salary: "ROLE_GET_MONTHLY_PAY",
  contract: "ROLE_GET_CONTRACT",
  domain: "ROLE_GET_DOMAIN",
  internal_training_comments: "ROLE_GET_INTERNAL_TRAINING",
  dashboard_comment: "ROLE_GET_DASHBOARD_COMMENT",
  manager: "ROLE_GET_MANAGER",
};

export const ROLE_CREATE_BY_MODEL = {
  internal_training_comments: "ROLE_CREATE_INTERNAL_TRAINING",
  dashboard_comment: "ROLE_CREATE_DASHBOARD_COMMENT",
};

export const ROLE_DELETE_BY_MODEL = {
  internal_training_comments: "ROLE_DELETE_INTERNAL_TRAINING",
  dashboard_comment: "ROLE_DELETE_DASHBOARD_COMMENT",
};

export const ROLE_ADMIN_BY_MODEL = {
  dashboard_comment: "ROLE_ADMIN_DASHBOARD_COMMENT",
};

export const ROLE_READ_BY_MODEL = {
  dashboard_comment: "ROLE_READ_DASHBOARD_COMMENT",
};
